import Button from '@berlitz/button'
import { H3 } from '@berlitz/globals'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'

import HR from '../../../components/HR'
import { FlagProps } from './interface'

export const StyledAlertCol = styled(Col)`
  margin-bottom: 7px;
  & > div {
    max-width: max-content;
    margin-bottom: 0;
    .content {
      padding-left: 3px;
    }
  }
`

export const StyledH3 = styled(H3)`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`

export const StyledButton = styled(Button)`
  border: none;
  margin-right: ${({ theme }) => theme.space.sm};

  &:last-child {
    margin: 0;
  }
`

export const ModalDescription = styled.div`
  margin-bottom: ${({ theme }) => theme.space.xxxl};
  font-size: ${({ theme }) => theme.fontSize.sm};
`

export const ViewProfile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: max-content;
  padding: ${({ theme }) => theme.space.sm};
  background-color: ${({ theme }) => theme.palette.blue20};
  color ${({ theme }) => theme.colors.brandPrimary};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  a {
    margin-left: ${({ theme }) => theme.space.md};
  }
`

export const Requirement = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.blueGray60};
  margin-bottom: ${({ theme }) => theme.space.xxs};

  &.has-uppercase {
    color: ${({ theme }) => theme.colors.uiWarningContrast};
  }

  &.has-special-char {
    color: ${({ theme }) => theme.colors.uiWarningContrast};
  }

  &.is-length-long {
    color: ${({ theme }) => theme.colors.uiWarningContrast};
  }

  svg {
    margin-right: ${({ theme }) => theme.space.xs};
  }
`

export const SubmitWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${({ theme }) => theme.space.xxxl};
`

export const Flag = styled.div<FlagProps>`
  width: 38px;
  height: 38px;
  border: 1px solid ${({ theme }) => theme.palette.gray100};
  border-radius: ${({ theme }) => theme.layout.xxxl};
  margin-right: ${({ theme }) => theme.space.xs};
  background-color: ${({ theme }) => theme.palette.white};
  background-image: ${({ country }) => `url('/images/flags/${country}.png')`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${({ theme, selected }) =>
    selected &&
    css`
      border: 3px solid ${theme.palette.blue100};
    `}
`

export const Flags = styled.div`
  display: flex;
  flex-direction: row;
`

export const StyledHR = styled(HR)`
  margin: ${({ theme }) => `${theme.space.md} 0`};
`

export const StyledA = styled.a`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.brandPrimary};
  cursor: pointer;
`

export const Label = styled.div<{ warning?: boolean; error?: boolean }>`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: 1.3;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space.xxs};

  ${({ warning }) =>
    warning &&
    css`
      color: #d87515;
      margin-top: ${({ theme }) => theme.space.xxs};

      span {
        svg {
          margin-left: 0;
          margin-right: ${({ theme }) => theme.space.xxs};
        }
      }
    `}

  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.uiError};
      margin-top: ${({ theme }) => theme.space.xxs};

      span {
        svg {
          margin-left: 0;
          margin-right: ${({ theme }) => theme.space.xxs};
        }
      }
    `}

  span {
    svg {
      margin-left: ${({ theme }) => theme.space.xxs};
    }
  }
`

export const StyledCol = styled(Col)`
  margin-top: ${({ theme }) => theme.space.md};
  margin-bottom: ${({ theme }) => theme.space.md};

  input {
    border: 1px solid ${({ theme }) => theme.palette.gray100};
    padding: ${({ theme }) => theme.space.xs};
  }
`

export const StyledRow = styled(Row)`
  &:first-child {
    margin-top: ${({ theme }) => theme.space.md};
  }

  button {
    border: none;

    &[disabled] {
      background-color: ${({ theme }) => theme.palette.gray20};
      color: ${({ theme }) => theme.palette.gray100};
    }
  }
`

export const Wrapper = styled.div`
  ${SubmitWrapper} {
    margin-bottom: 0;
    justify-content: center;

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      justify-content: flex-end;
    }
  }
`
